import { z } from 'zod';
import { SELECTABLE_PAYMENT_METHODS } from '../types/invoicePayment';

/** Two decimal places, positive. Rejects the float noise a text input can produce. */
const money = z.number().positive().multipleOf(0.01);

export const recordPaymentSchema = z.object({
  amount: money,
  receivedOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  // Built from the selectable list, so 'external' — which marks migrated
  // records — is rejected by the type as well as at runtime.
  method: z.enum(SELECTABLE_PAYMENT_METHODS),
  reference: z.string().max(120).nullish(),
});

/** An amend supersedes a row; same shape, applied to an existing payment. */
export const amendPaymentSchema = recordPaymentSchema;

export const reversePaymentSchema = z.object({
  reason: z.string().min(1).max(500),
});

export type RecordPaymentInput = z.infer<typeof recordPaymentSchema>;
export type AmendPaymentInput = z.infer<typeof amendPaymentSchema>;
export type ReversePaymentInput = z.infer<typeof reversePaymentSchema>;
